import { Interval } from 'app/agriculture/AgTimeline/types';
import { addMilliseconds, differenceInMilliseconds } from 'date-fns';

/**
 * Calculates the date represented by the percentage of an interval
 * (e.g. 10% of a 6 hour interval would be 36 minutes after the start Date)
 * @param percentage A percentage from 0-100
 * @param interval The interval we want to know the percentage date of
 */
export function percentageToDate(percentage: number, interval: Interval<Date>) {
    const { start, end } = interval;
    return addMilliseconds(start, differenceInMilliseconds(end, start) * (percentage / 100));
}
